module.exports = __webpack_public_path__ + "assets/87a1f7eed72fcc6c7880026d0b6cb27a.png";